export class EvenementSessionModel {
  id!: string;
  sessionId!: number;
  type!: string;
  reponse!: string;
  resultat!: string;
  dateEvenement!: Date;
  duree!: string;
}
